export default {
  isMember(state) {
    return state.userIdTokenResult?.claims?.user_type === 'member';
  },
};
